import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import Connect from "./pages/Connect";
import redirects from "./data/redirects.json";

const WorkWithMe = lazy(() => import("./pages/WorkWithMe"));
const PrivateSessions = lazy(() => import("./pages/PrivateSessions"));
const Massage = lazy(() => import("./pages/Massage"));
const ClassesPage = lazy(() => import("./pages/ClassesPage"));
const PracticeOnline = lazy(() => import("./pages/PracticeOnline"));
const SutrasApp = lazy(() => import("./pages/SutrasApp"));
const Workshops = lazy(() => import("./pages/Workshops"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const Retreats = lazy(() => import("./pages/Retreats"));
const Contact = lazy(() => import("./pages/Contact"));
const Privacy = lazy(() => import("./pages/Privacy"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const GuidedPrograms = lazy(() => import("./pages/GuidedPrograms"));
const ProgramDetail = lazy(() => import("./pages/ProgramDetail"));
const AdminApp = lazy(() => import("./pages/admin/AdminApp"));

const REDIRECTS = redirects.exact;

function App() {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <Routes>
          <Route path="connect" element={<Connect />} />
          <Route path="links" element={<Navigate to="/connect" replace />} />
          <Route path="studio" element={<Navigate to="/admin/studio" replace />} />
          <Route
            path="admin/*"
            element={
              <Suspense fallback={<div className="min-h-screen bg-ivory" />}>
                <AdminApp />
              </Suspense>
            }
          />
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="work-with-me" element={<WorkWithMe />} />
            <Route path="private-sessions" element={<PrivateSessions />} />
            <Route path="massage-bodywork" element={<Massage />} />
            <Route path="classes" element={<ClassesPage />} />
            <Route path="practice-online" element={<PracticeOnline />} />
            <Route path="guided-programs" element={<GuidedPrograms />} />
            <Route path="guided-programs/:slug" element={<ProgramDetail />} />
            <Route path="yoga-sutras-app" element={<SutrasApp />} />
            <Route path="yoga-sutras-workshops" element={<Workshops />} />
            <Route path="jakeferree-bio" element={<AboutPage />} />
            <Route path="retreatsandevents" element={<Retreats />} />
            <Route path="contact" element={<Contact />} />
            <Route path="yoga-sutras-presence-revealed-privacy-policy" element={<Privacy />} />
            <Route path="unsubscribe" element={<Unsubscribe />} />
            <Route path="free-yoga-challenge" element={<Navigate to="/guided-programs/5-day-yoga-challenge" replace />} />
            {Object.entries(REDIRECTS).map(([from, to]) => (
              <Route key={from} path={from} element={<Navigate to={to} replace />} />
            ))}
            {Object.entries(redirects.prefixes).map(([from, to]) => (
              <Route key={from} path={`${from}*`} element={<Navigate to={to} replace />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;
